import { render, staticRenderFns } from "./SQLEditor.vue?vue&type=template&id=2921e579&"
import script from "./SQLEditor.vue?vue&type=script&lang=ts&"
export * from "./SQLEditor.vue?vue&type=script&lang=ts&"
import style0 from "./SQLEditor.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports